import axios from 'axios';

import { CLOUD_FUNCTION_URL } from '../../env';
import { getAuthHeaderForUser } from '../auth/auth.util';

export type ChatMessage = { role: 'user' | 'model'; content: string };
export type ReportId = 'quantified_risk' | 'forecasting';

export async function sendChatMessage(
  messages: ChatMessage[],
  reportId: ReportId
): Promise<string> {
  const response = await axios.post(
    `${CLOUD_FUNCTION_URL}/syntiroAiChat`,
    { messages, reportId },
    { headers: { ...(await getAuthHeaderForUser()) } }
  );
  return response.data.data.reply;
}
